/**
 * HomeRedirect — 메인("/") 진입 시, 그 계정이 실제로 들어갈 수 있는 첫 페이지로 보낸다.
 *
 * 예전엔 "/"가 무조건 /crm/customers로 고정 리다이렉트했다. CRM 권한이 없는 계정은
 * 거기서 RBACRoute에 막혀 다시 "/"로 튕겨나와 무한 루프에 빠졌다. 이제 진입점은
 * 권한에서 계산되는 값이다 — 권한 로딩 중엔 can()이 true라 첫 후보(CRM)로 가고,
 * 로드 후 권한이 확정되면 다시 렌더되어 올바른 첫 페이지로 정착한다.
 */

import { Navigate } from "react-router";
import { useAuth } from "../../context/AuthContext";
import { useEdition, withExternalSearch } from "../../context/EditionContext";
import { firstAccessiblePath } from "../../lib/landing";
import { externalHomePath } from "../../../shared/external-edition";
import NoAccess from "../../pages/OtherPage/NoAccess";

export default function HomeRedirect() {
  const { can } = useAuth();
  const { edition, enabledFeatures } = useEdition();

  // 외부 배포용 화면에서는 권한으로 계산하지 않는다 — 권한상 CRM 이 열려 있어도(라인업 계정이
  // 미리보기로 들어온 경우) 선택 이용 매장에게는 그 화면이 없다. 열어 준 첫 기능이 곧 첫 화면이다.
  // 표(`?edition=trial`)를 여기서부터 붙여 보낸다 — 가드가 어차피 붙이지만, 처음부터
  // 붙여 보내면 리다이렉트가 한 번 덜 돈다.
  // 열린 게 하나도 없으면 보낼 곳이 없다 — 그대로 두면 착지점이 "/" 라 여기로 되돌아와
  // 무한 왕복이 된다. 그 경우의 안내는 ExternalEditionGate 가 그린다(그쪽 머리말 §③).
  if (edition === "partial" && enabledFeatures.length > 0) {
    return (
      <Navigate
        to={{ pathname: externalHomePath(enabledFeatures), search: withExternalSearch("") }}
        replace
      />
    );
  }

  const landing = firstAccessiblePath(can);
  return landing ? <Navigate to={landing} replace /> : <NoAccess />;
}
